import { MenuItem, Typography } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import IconeQuantidade from '../IconeQuantidade';
import ReactComponent from '../ReactComponent';

class AlertaPeticoesPendentes extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            quantidadePeticoesPendentes: computed,
            handleClickIcone: action,
            descricaoPeticoesPendentes: computed
        });
    }

    get quantidadePeticoesPendentes() {
        return this.store.processosPautaSelecionada.filter(
            (registro) =>
                registro.informacoesAdicionais && registro.informacoesAdicionais.QuantidadePeticoesPendentes > 0
        ).length;
    }

    handleClickIcone = () => {
        this.store.alterarProcessosEmExibicao('P');
        this.store.alterandoValorFiltro = true;
        this.setTimeout(() => {
            this.store.filtros.reset();
            this.store.filtros.filtroPeticoesPendentes.valor = true;
            this.store.alterandoValorFiltro = false;
        });
    };

    get descricaoPeticoesPendentes() {
        return (
            this.quantidadePeticoesPendentes +
            (this.quantidadePeticoesPendentes === 1
                ? ' processo em pauta/sessão com petição pendente'
                : ' processos em pauta/sessão com petições pendentes')
        );
    }

    render() {
        if (!this.quantidadePeticoesPendentes || this.quantidadePeticoesPendentes <= 0) {
            return null;
        }

        return (
            <MenuItem
                style={{ display: 'flex', cursor: 'pointer' }}
                onClick={this.handleClickIcone}
            >
                <IconeQuantidade
                    quantidade={this.quantidadePeticoesPendentes}
                    style={{ marginRight: '12px', color: 'darkorange', fillOpacity: '1' }}
                />
                <Typography>{this.descricaoPeticoesPendentes}</Typography>
            </MenuItem>
        );
    }
}

export default inject('stores')(observer(AlertaPeticoesPendentes));
